import React__default from 'react';
import PropTypes from 'prop-types';
import { backgroundPresets, brands } from '../../tools/constants.js';

var propTypes = {
  children: PropTypes.node.isRequired,
  background: PropTypes.oneOf(backgroundPresets),
  /**
   * Used with background presets
   */
  brand: PropTypes.oneOf(brands),
  footer: PropTypes.node,
  groupBackground: PropTypes.node,
  hasPaddingHorizontal: PropTypes.bool,
  hasPaddingVertical: PropTypes.bool,
  hasSeparator: PropTypes.bool,
  header: PropTypes.node,
  variant: PropTypes.oneOf(['horizontal-collapsed', 'horizontal-spaced', 'vertical-collapsed', 'vertical-spaced'])
};
function ToutGroup(_ref) {
  var background = _ref.background,
    brand = _ref.brand,
    children = _ref.children,
    footer = _ref.footer,
    groupBackground = _ref.groupBackground,
    _ref$hasPaddingHorizo = _ref.hasPaddingHorizontal,
    hasPaddingHorizontal = _ref$hasPaddingHorizo === void 0 ? 'false' : _ref$hasPaddingHorizo,
    _ref$hasPaddingVertic = _ref.hasPaddingVertical,
    hasPaddingVertical = _ref$hasPaddingVertic === void 0 ? 'false' : _ref$hasPaddingVertic,
    _ref$hasSeparator = _ref.hasSeparator,
    hasSeparator = _ref$hasSeparator === void 0 ? 'false' : _ref$hasSeparator,
    header = _ref.header,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'horizontal-spaced' : _ref$variant;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tout-group",
    "data-background": background || null,
    "data-brand": brand || null,
    "data-padding-horizontal": hasPaddingHorizontal,
    "data-padding-vertical": hasPaddingVertical,
    "data-separator": hasSeparator,
    "data-testid": "tout-group",
    "data-variant": variant
  }, groupBackground ? /*#__PURE__*/React__default.createElement("div", {
    className: "tout-group-background",
    "data-testid": "tout-group-background"
  }, groupBackground) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "tout-group-wrapper",
    "data-testid": "tout-group-wrapper"
  }, header ? /*#__PURE__*/React__default.createElement("div", {
    className: "tout-group-header",
    "data-testid": "tout-group-header"
  }, header) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "tout-group-content",
    "data-testid": "tout-group-content"
  }, children), footer ? /*#__PURE__*/React__default.createElement("div", {
    className: "tout-group-footer",
    "data-testid": "tout-group-footer"
  }, footer) : null));
}
ToutGroup.propTypes = propTypes;

export { ToutGroup as default };
//# sourceMappingURL=ToutGroup.js.map
